import styled from "styled-components";
import { Form } from '@unform/web';





export const FieldsForm = styled(Form)`
    margin-bottom:10px;

`;